/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Announcement, AnnouncementFromJSON, AnnouncementFromJSONTyped, AnnouncementToJSON } from './Announcement'
import { PageInfo, PageInfoFromJSON, PageInfoFromJSONTyped, PageInfoToJSON } from './PageInfo'

/**
 *
 * @export
 * @interface GetAnnouncementsResponseData
 */
export interface GetAnnouncementsResponseData {
  /**
   *
   * @type {Array<Announcement>}
   * @memberof GetAnnouncementsResponseData
   */
  announcements?: Array<Announcement>
  /**
   *
   * @type {PageInfo}
   * @memberof GetAnnouncementsResponseData
   */
  pageInfo?: PageInfo
  /**
   *
   * @type {number}
   * @memberof GetAnnouncementsResponseData
   */
  unreadCount?: number
}

export function GetAnnouncementsResponseDataFromJSON(json: any): GetAnnouncementsResponseData {
  return GetAnnouncementsResponseDataFromJSONTyped(json, false)
}

export function GetAnnouncementsResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetAnnouncementsResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    announcements: !exists(json, 'announcements')
      ? undefined
      : (json['announcements'] as Array<any>).map(AnnouncementFromJSON),
    pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info']),
    unreadCount: !exists(json, 'unread_count') ? undefined : json['unread_count']
  }
}

export function GetAnnouncementsResponseDataToJSON(value?: GetAnnouncementsResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    announcements:
      value.announcements === undefined ? undefined : (value.announcements as Array<any>).map(AnnouncementToJSON),
    page_info: PageInfoToJSON(value.pageInfo),
    unread_count: value.unreadCount
  }
}
